import {Component, OnInit, OnDestroy} from "@angular/core";
import {PricingModal} from "../../../../app/components/pricing-modal/pricing-modal.component";
import {ModalController} from "ionic-angular";
import {RoleService} from "../../../../app/core/role.service";

@Component ({
  templateUrl: 'empty-state.component.html',
  selector: 'app-empty-state'
})

export class EmptyState implements OnInit, OnDestroy {
  role: string;
  roleSub: any;

  constructor(
    private modalCtrl: ModalController,
    private roleService: RoleService
  ){}

  ngOnInit(): any {
    this.roleSub = this.roleService.getRole()
      .subscribe(role => this.role = role);
  }

  ngOnDestroy(): any {
    this.roleSub.unsubscribe();
  }

  showPricingModal() {
    let modal = this.modalCtrl.create(PricingModal);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/jobs-list/shared/empty-state/empty-state.component.ts